import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-header',
    templateUrl: './user-header.component.html',
    standalone: false
})
export class UserHeaderComponent implements OnInit {
  @Input() selectedHeader: string;
  @Input() tableCategory: string;
  constructor() {}

  ngOnInit(): void {}
}
